module.exports = __webpack_public_path__ + "media/assets/img/flags/pl-PL-49e730e61305c12664ba071bab1f84a7.png";